import React, { FC, memo } from 'react';
import { Tooltip } from 'antd';
import styles from '../MaintenanceTriggerForm.module.scss';
import { IdText, ResponseLevel } from '../MaintenanceTriggerForm.slice';
import { FindingTypeDetails } from '../../../AnnotationManager/AnnotationStandardForm/AnnotationStandardForm.slice';
import { defectLocations, PropConstants, InputProperty, SelectInputProperty, tresholdColumns, commonColumns } from '../Helpers';
import { FormDataInitial } from '../formSelector';

type Props = {
  editMode: boolean;
  rule: any;
  column: IdText;
  findingType: FindingTypeDetails | null;
  findingTypes: IdText[];
  responseLevels: ResponseLevel[];
  formData: FormDataInitial;
  onCellUpdated: (key: string | number, value: string) => void;
};

export const Cell: FC<Props> = memo(({ editMode, rule, column, findingType, findingTypes, responseLevels, onCellUpdated }) => {
  const columnValues = new Map<string | number, IdText[]>([
    [PropConstants.FINDING_TYPE, findingTypes],
    [PropConstants.DEFECT_LOCATION, defectLocations],
    [PropConstants.RESPONSE_LEVEL_ACTION, responseLevels.map(x => ({ id: x.id, text: x.name }))]
  ]);

  //TODO blade zone should be improved
  const getColumnValues = (key: string | number) => {
    let bladeZoneHack = false;
    if (key === 'defectLocation' && findingType && findingType.findingTypeTemplate?.properties.find(x => x.name === 'BladeZone')) {
      bladeZoneHack = true;
    }

    if (!bladeZoneHack && columnValues.has(key)) {
      return columnValues.get(key)!;
    }

    if (findingType) {
      if (bladeZoneHack) {
        let values = getIdTextPropertyValues('BladeZone');
        if (values) {
          return [{ id: 0, text: ' ' }, ...values];
        }
      }

      return getIdTextPropertyValues(key);
    }

    return undefined;
  };

  const getIdTextPropertyValues = (key: string | number) => {
    const property = findingType!.findingTypeTemplate!.properties.find(x => x.name === key);
    if(property) {
      if (property.values) {
        return property.values.split(',').map(x => ({
          id: x.trim(),
          text: x.trim()
        }));
      }

      return [];
    }

    if(tresholdColumns.find(x => x.id === key) ||
       ['comments', 'responseLevel', 'responseLevelDescription'].find(x => x === key)) {
      return [];
    }

    return undefined;
  };

  const getInputField = (column: IdText) => {
    const values = getColumnValues(column.id);

    if (values && values.length) {
      return SelectInputProperty(values, column.id, rule[column.id], onCellUpdated);
    }

    return InputProperty(column.id, rule[column.id], onCellUpdated, !values); //What in case when there is different number of props for type in same standard?
  };

  const getFieldValue = (column: IdText) => {
    const values = getColumnValues(column.id);

    if (values && values.length) {
      const field = values.find(x => x.id === rule[column.id]);
      return field ? field.text : '';
    }

    return rule[column.id];
  };

  if (editMode) {
    return <td className={styles.column}>{getInputField(column)}</td>;
  }

  return (
    <Tooltip placement='top' title={column.id === 'responseLevelDescription' ? rule.responseLevelDescription : ''}>
      <td style={{ height: '65px' }}>
        <span className={styles.textBox}>{getFieldValue(column)}</span>
      </td>
    </Tooltip>
  );
});

export default Cell;
